/**
 * The request types when instantiating a RequestInit.method object when calling REST APIs/
 */
export class HttpMethodType {
    public static Get: string = "GET";
    public static Put: string = "PUT";
    public static Post: string = "POST";
    public static Patch: string = "PATCH";
    public static Delete: string = "DELETE";
}